module.exports = __webpack_public_path__ + "static/media/flashcards.472c6863.png";